// @ts-nocheck

/**
 * YPM_CONSTRUCTION_V_CDS
 * Construction  ## Entity Data Model ![ER Diagram](https://yuml.me/diagram/class/[YPM_CONSTRUCTION_VType{bg:orange}],[YPM_CONSTRUCTION_VType]-*>[YPM_EQUIPMENT_VType{bg:orange}],[YPM_CONSTRUCTION_VType]-*>[YPM_NOTIF_vType{bg:orange}],[YPM_EQUIPMENT_VType{bg:orange}],[YPM_NOTIF_vType{bg:orange}],[YPM_CONSTRUCTION_V{bg:dodgerblue}]++-*>[YPM_CONSTRUCTION_VType],[YPM_EQUIPMENT_V{bg:dodgerblue}]++-*>[YPM_EQUIPMENT_VType],[YPM_NOTIF_v{bg:dodgerblue}]++-*>[YPM_NOTIF_vType])  ### Legend ![Legend](https://yuml.me/diagram/plain;dir:TB;scale:60/class/[External.Type{bg:whitesmoke}],[ComplexType],[EntityType{bg:orange}],[EntitySet/Singleton/Operation{bg:dodgerblue}])
 *
 * The version of the OpenAPI document: 0001
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { ModelError } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class BatchRequestsService {

    protected basePath = 'https://sapd42c00.sap.corp.lego.com:22000/sap/opu/odata/sap/YPM_CONSTRUCTION_V_CDS';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Send a group of requests
     * Group multiple requests into a single request payload, see [Batch Requests](http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#sec_BatchRequests).  *Please note that \&quot;Try it out\&quot; is not supported for this request.*
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchPost(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'multipart/mixed' | 'application/json'}): Observable<string>;
    public batchPost(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'multipart/mixed' | 'application/json'}): Observable<HttpResponse<string>>;
    public batchPost(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'multipart/mixed' | 'application/json'}): Observable<HttpEvent<string>>;
    public batchPost(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'multipart/mixed' | 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'multipart/mixed',
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<string>(`${this.configuration.basePath}/$batch`,
            null,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
